import $ from "jquery";
import { debounce } from "../utils/functions";

const $window = $(window);
const $body = $("body");
const $hamburger = $(".hamburger");
const $searchTrigger = $(".navigation__search");
const $navLang = $(".lang-switcher");
const $navMiscLink = $(".navigation__misc_link");
const $navButton = $(".navigation__button");
const $navMenu = $(".navigation-menu");
const $navMenuTitle = $(".navigation-menu__title");
const $navSubmenuWrapper = $(".navigation-submenu__wrapper");
const $navSubmenuLink = $(".navigation-submenu__link");
const $headerLogo = $(".header__logo");
const $searchMisc = $(".navigation__search");
const $skipHeader = $("#skip-header");
const breakpoint = 1439;

$(function () {
  $window.on("resize:width", debounce(hideNav, true));
  $(document).on("keydown", function (event) {
    if (event.keyCode === 27) {
      hideNav();
    }
  });
  $skipHeader.on("click", skipHeader);
  $hamburger.on("click", toggleNav);
  $navMenuTitle.on({
    click: function (event) {
      event.stopPropagation();
      const trigger = $(this);
      if (trigger.hasClass("active")) {
        hideMenu();
        return;
      }
      const menu = trigger.parent().find(".navigation-submenu");
      showMenu(trigger, menu);
    },
    mouseover: function () {
      const trigger = $(this);
      const menu = trigger.parent().find(".navigation-submenu");
      if (menu.length !== 0 && $window.width() > breakpoint) {
        setTimeout(() => {
          showMenu(trigger, menu);
        }, 200);
        //debounce(showMenu(trigger, menu));
      }
    },
    mouseleave: function () {
      const trigger = $(this);
      const menu = trigger.parent().find(".navigation-submenu");
      if (menu.length !== 0 && $window.width() > breakpoint) {
        if (menu.filter(":hover").length === 0) {
          setTimeout(() => {
            hideMenu(true);
          }, 200);
          //debounce(hideMenu(true));
        }
      }
    },
    focus: function () {
      const trigger = $(this);
      const menu = trigger.parent().find(".navigation-submenu");
      if (menu.length !== 0 && $window.width() > breakpoint) {
        showMenu(trigger, menu);
      } else hideMenu(true);
    },
    // focusin: function () {
    //   const trigger = $(this);
    //   const menu = trigger.parent().find(".navigation-submenu");
    //   if (menu.length !== 0 && $window.width() > breakpoint) {
    //     toggleMenu(trigger, menu);
    //   }
    // },
  });
  $navSubmenuWrapper.on({
    click: function (event) {
      const $clickTarget = $(event.target);
      if (!$clickTarget.hasClass("modal-trigger")) {
        event.stopPropagation();
      }
    },
    mouseleave: function () {
      const menu = $(this);
      const trigger = menu.parent().parent().find(".navigation-menu__title");
      if (
        trigger.filter(":hover").length === 0 &&
        $window.width() > breakpoint
      ) {
        hideMenu();
      }
    },
  });
  $body.on("click", hideMenu);
  $searchTrigger.on("click", hideNav);
  $navButton.on("click", hideNav);
  $navMiscLink.on("click", hideNav);
  $navSubmenuLink.on("click", hideNav);
});

function skipHeader() {
  $(".page__header")
    .next()
    .find(":input, a, area, iframe, button")
    .first()
    .focus();
}

function toggleNav() {
  if ($navMenu.is(":hidden")) {
    showNav();
  } else {
    hideNav();
  }
}

function showNav() {
  $navMenu.addClass("active");
  $hamburger.addClass("active");
  $navLang.addClass("active");
  $headerLogo.hide();
  $searchMisc.hide();
  showMenu();
}

function hideNav() {
  $navMenu.scrollTop(0);
  $navMenu.removeClass("active");
  $hamburger.removeClass("active");
  $navLang.removeClass("active");
  $headerLogo.show();
  $searchMisc.show();
  hideMenu();
}

function toggleMenu(trigger, menu) {
  if (menu.hasClass("active")) {
    hideMenu();
  } else {
    showMenu(trigger, menu);
  }
}

function showMenu(trigger, menu) {
  hideMenu(true);
  const subMenu = $(".navigation-submenu.active:hover");
  if (subMenu.length == 0) {
    setTimeout(function () {
      menu.addClass("active");
      trigger.addClass("active");
    }, 0);
    $navSubmenuLink.removeAttr("tabindex");
  }
}

function hideMenu(slow = false) {
  const subMenu = $(".navigation-submenu.active:hover");
  if (!slow || subMenu.length == 0) {
    $(".navigation-submenu.active").removeClass("active");
    $(".navigation-menu__title.active").removeClass("active");
    $navSubmenuLink.attr("tabindex", -1);
  }
}
